export const PHONE_TEL = "tel:+390456402529";
export const PHONE_DISPLAY = "+39 045 640 2529";
export const MENU_URL = "https://www.thecubedesign.it/m/ristorante-gune";
export const ADDRESS = "Via XXV Aprile 80, 37014 Castelnuovo del Garda (VR)";
export const MAPS_URL =
  "https://www.google.com/maps/search/?api=1&query=Ristorante%20Gun%C3%A8%20Via%20XXV%20Aprile%2080%20Castelnuovo%20del%20Garda";
export const MAPS_EMBED =
  "https://www.google.com/maps?q=Via+XXV+Aprile+80,+37014+Castelnuovo+del+Garda+VR&z=14&output=embed";
export const INSTAGRAM_URL = "https://www.instagram.com/guneristorantepizzeria/";
export const FACEBOOK_URL = "https://www.facebook.com/ristorantepizzeriagune/";
export const GOOGLE_BUSINESS_URL = "https://share.google/7QtUbXURaVCjBJEo7";
export const TRIPADVISOR_URL =
  "https://www.tripadvisor.com/Restaurant_Review-g644289-d1420482-Reviews-Ristorante_Pizzeria_Gune-Castelnuovo_del_Garda_Province_of_Verona_Veneto.html";
export const WEBSITE_URL = "https://www.ristorantepizzeriagune.com/";
export const DIAMOND_URL = "https://www.diamondinnovations.eu";
